import EventEmitter from 'wolfy87-eventemitter';
import type { ICalendarController, ICalendarEvents } from './calendar.interface';
import { CALENDAR_MODULE_IDS } from './calendar.types';
import { inject, injectable } from 'inversify';

@injectable()
export class CalendarController extends EventEmitter implements ICalendarController {
  @inject(CALENDAR_MODULE_IDS.CALENDAR_EVENTS) public events: ICalendarEvents;

  top: number | null;

  right: number | null;

  constructor() {
    super();

    this.show = this.show.bind(this);
    this.hide = this.hide.bind(this);
  }

  show({ top, right }) {
    this.top = top;
    this.right = right;

    this.emit(this.events.UPDATE, { top: this.top, right: this.right });
  }

  hide() {
    this.top = null;
    this.right = null;

    this.emit(this.events.UPDATE, { top: this.top, right: this.right });
  }
}
